export default __webpack_public_path__ + "static/media/dietandmentalhealth2.78edfc5b.jpg";